import { render } from "./SuccessLog.vue?vue&type=template&id=65a7896e"
import script from "./SuccessLog.vue?vue&type=script&lang=js"
export * from "./SuccessLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__